import styled from 'styled-components';
import {
  fontVariables,
  gutterVariables,
  Heading
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { minWidth } from 'helpers/buildMediaQueries';

export const CardHeader = styled.div<{ $isSingleElement: boolean }>`
  grid-area: header;
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto;
  padding: 12px 18px;
  align-items: center;
  justify-content: space-between;

  ${minWidth('xl', `padding: 12px ${gutterVariables.GUTTER_PLUS_HALF};`)}

  ${(props) =>
    props.$isSingleElement ? `border-radius: 8px;` : `margin-bottom: 12px;`};
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: end;
  width: 88px;
  max-width: 88px;
  height: 44px;
  max-height: 44px;

  ${minWidth(
    'md',
    `
      width: 112px;
      max-width: 112px;
      height: 56px;
      max-height: 56px;
    `
  )}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;

    &.clickable {
      cursor: pointer;
    }
  }
`;

export const HeadingName = styled(Heading)`
  font-size: ${fontVariables.SIZE_TEXT_M};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
